import FaqImg from '../../static/assets/homepage/home-contacts-img.svg';
import ContactUsForm from '../ContactUs/ContactUsForm';
import FaqList from './FaqList';

import './HomeFaq.scss';

const HomeFaq = () => (
	<section className="home-faq home-section">
		<div className="internal-wrapper">
			<div className="home-section-header">
				<h2 className="home-faq__title title-section title">FAQ</h2>
				<p className="home-faq__subtitle subtitle-section">
					Javascript common patterns
				</p>
			</div>
		</div>
		<div className="home-faq__wrapper">
			<div className="internal-wrapper">
				<div className="home-faq__internal-wrapper">
					<div className="home-faq__items-external-wrapper">
						<FaqList />
						<div className="home-faq__img-wrapper">
							<img className="home-faq__img" src={FaqImg} alt="Codeway.TODAY" />
						</div>
					</div>
					<div className="home-faq__contact-us">
						<h2 className="home-faq__contact-us-title title title-medium">
							Still didn’t find the right answer?{' '}
							<span style={{ color: '#FF7062' }}>Contact us</span>
						</h2>
						<div className="home-faq__contact-us-form">
							<ContactUsForm />
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
);

export default HomeFaq;
